import { AnalyticsSettingsClients } from '@ms/yammer-graphql';

import { NormalizeAnalyticsAdminSettings } from './types';

type AnalyticsAdminSettingsNormalizer = (response: {
  readonly data: AnalyticsSettingsClients;
}) => NormalizeAnalyticsAdminSettings;

export const normalizeAnalyticsAdminSettings: AnalyticsAdminSettingsNormalizer = (response) => ({
  isOverallSentimentInLeadershipActivityEnabled:
    response.data.settings.analytics.isOverallSentimentInLeadershipActivityEnabled,
  isSentimentPerTopThemeInLeadershipActivityEnabled:
    response.data.settings.analytics.isSentimentPerTopThemeInLeadershipActivityEnabled,
  isSentimentPerTopThreadInLeadershipActivityEnabled:
    response.data.settings.analytics.isSentimentPerTopThreadInLeadershipActivityEnabled,
  isTopThreadStarterSendersInCampaignActivityEnabled:
    response.data.settings.analytics.isTopThreadStarterSendersInCampaignActivityEnabled,
  isTimeSavedAndPeopleHelpedInNetworkQuestionActivityEnabled:
    response.data.settings.analytics.isTimeSavedAndPeopleHelpedInNetworkQuestionActivityEnabled,
  viewerCanEditSettings: response.data.settings.analytics.viewerCanEditSettings,
});
